
export default {
  install(Vue) {
    Vue.directive("loading", {
      inserted(el, binding, vnode) {
        let loadingMask = document.createElement("div");
        loadingMask.className = "loading-mask";
        el.prepend(loadingMask);
        if (binding.value) {
          loadingMask.className += " is-active";
        }
      },
      update(el, binding, vnode) {
        let loadingMask = el.getElementsByClassName("loading-mask")[0]; // Get the first div in the node
        if (binding.value) {
          loadingMask.className = "loading-mask is-active";
        } else {
          loadingMask.className = "loading-mask";
        }
      }
    });
  }
};
